var _path, _rect, _rect2, _rect3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 278,
    viewBox: "0 0 335 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.813 40.0414C292.671 44.1429 295.099 54.3703 296.43 66.2368C296.659 68.2787 296.855 70.3699 297.054 72.4793C297.427 76.4466 297.806 80.4781 298.417 84.3657C299.356 90.3341 300.852 96.0511 303.759 100.848C306.594 105.525 310.566 109.389 314.947 112.879C318.052 115.353 321.385 117.656 324.675 119.93C326.019 120.859 327.357 121.784 328.668 122.712C337.761 129.151 345.652 135.842 347.145 146.285C348.654 156.846 345.21 166.895 339.499 176.29C333.786 185.689 325.835 194.385 318.398 202.229C304.26 217.142 286.615 231.015 266.31 231.492C256.828 231.714 248.753 227.37 240.886 221.739C238.252 219.854 235.658 217.838 233.045 215.806C231.75 214.8 230.451 213.79 229.139 212.79C225.191 209.781 221.154 206.881 216.889 204.533C213.297 202.556 209.472 200.954 205.625 199.457C204.364 198.966 203.103 198.488 201.847 198.011C199.259 197.028 196.691 196.054 194.187 194.998C186.76 191.865 180.041 188.071 175.5 181.484C166.201 167.996 167.137 150.413 168.056 133.79C168.071 133.507 168.087 133.223 168.103 132.939C168.551 124.796 169.013 116.423 170.65 108.539C172.344 100.386 175.288 92.7948 180.746 86.5661C186.129 80.4231 193.473 77.5634 201.439 75.383C203.611 74.7884 205.833 74.2438 208.072 73.6952C214 72.2427 220.044 70.7619 225.569 68.2503C230.615 65.9563 235.486 62.5018 240.252 58.7675C242.159 57.2732 244.042 55.7396 245.915 54.2148C248.746 51.91 251.552 49.6256 254.376 47.5278C263.754 40.5604 272.964 35.9442 282.813 40.0414Z",
    stroke: "#6C6C6C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.5859,
    y: 19.5752,
    width: 346.297,
    height: 230.578,
    stroke: "#6C6C6C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5801,
    y: 2.5,
    width: 379.373,
    height: 265.261,
    rx: 12.5,
    stroke: "#6C6C6C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 267.295,
    width: 477,
    height: 10.2054,
    rx: 5.10268,
    fill: "#0D0D0D",
    stroke: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.772 270.053C161.52 269.239 162.096 267.295 163.589 267.295H313.555C315.096 267.295 315.635 269.342 314.293 270.101L311.618 271.613C309.741 272.674 307.622 273.232 305.466 273.232H171.368C168.949 273.232 166.582 272.53 164.554 271.211L162.772 270.053Z",
    stroke: "#6C6C6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileComputer);
export default __webpack_public_path__ + "static/media/mobileComputer.db422fb827eb54a3548701f60cd1bc78.svg";
export { ForwardRef as ReactComponent };